import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconMemo, IconProps } from "@insite/mobius/Icon";
import File from "@insite/mobius/Icons/File";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProduct;

export interface ProductDetailsDocumentsStyles {
    wrapper?: InjectableCss;
    container?: InjectableCss;
    documentContainer?: InjectableCss;
    documentLink?: LinkPresentationProps;
    documentIcon?: IconProps;
    documentNameText?: TypographyPresentationProps;
    documentationTittle?: InjectableCss;
}

export const documentsStyles: ProductDetailsDocumentsStyles = {
    wrapper: {
        css: css`
            margin: 20px 0px;
        `,
    },
    documentContainer: {
        css: css`
            padding: 0px;
        `,
    },
    documentIcon: {
        src: File,
        color: "#000000",
        css: css`
            margin-right: 10px;
        `,
    },
    documentNameText: {
        css: css`
            vertical-align: super;
            color: #0068b6;
            font-size: 14px;
            font-weight: 500;
            height: 14px;
            letter-spacing: 0;
            line-height: 17px;
            &:hover {
                text-decoration: underline;
                text-decoration-color: #000000;
                color: #000000;
            }
        `,
    },
    documentationTittle: {
        css: css`
            box-sizing: border-box;
            display: inline-flex;
            font-weight: 600;
            color: #474747;
            font-size: 24px;
            text-transform: uppercase;
            margin-bottom: 10px;
        `,
    },
    container: {
        css: css`
            > div[class^="GridOffset"] {
                display: flex;
                flex-direction: column;
                row-gap: 5px;
            }
        `,
    },
};

const styles = documentsStyles;

const ProductDetailsDocuments: React.FC<OwnProps> = ({ product: { documents } }) => {
    if (!documents || documents.length === 0) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper>
                <Typography {...styles.documentationTittle}>DOCUMENTATION</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.container}>
                {documents.map(document => (
                    <StyledWrapper key={document.id.toString()} {...styles.documentContainer}>
                        <Link
                            href={document.filePath}
                            target="_new"
                            {...styles.documentLink}
                            data-test-selector={`productDetails_${document.id}`}
                        >
                            <IconMemo {...styles.documentIcon} />
                            <Typography {...styles.documentNameText}>{document.name}</Typography>
                        </Link>
                    </StyledWrapper>
                ))}
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsDocuments),
    definition: {
        displayName: "Documents",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
